import { fork } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';
import submitFeedback from './submitFeedback';
import { CUSTOMER_FEEDBACK_SUBMIT } from 'app/constants';


export default function* watchCustomerFeedback() {
  yield fork(takeLatest, CUSTOMER_FEEDBACK_SUBMIT, submitFeedback);
}
